import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NOTIFICATION_SERVICE } from './service-url'
import { EmailTemp } from '../model/chat.model';
@Injectable({
  providedIn: 'root'
})
export class EmailService {

  constructor(private http: HttpClient) { }

  public getemailList(): Observable<any> {
    
      return this.http.get(NOTIFICATION_SERVICE.emailList );
   
  }
  public createTemplate(request: EmailTemp):Observable<any>{
    if(request){
    return this.http.post(NOTIFICATION_SERVICE.createEmail,request)
    }
    else{
      return null;
    }
  }
  public deleteEmail(Id: number): Observable<any> {
    return this.http.delete(NOTIFICATION_SERVICE.deleteEmail + '/' + Id);
  }
  public updateEmailTemplate(request: { [key: string]: any },Id:number):Observable<any> {
    return this.http.put(`${NOTIFICATION_SERVICE.updateEmail}/${Id}`, request);
  }
  public getTemplateById(Id:number):Observable<any>{
    return this.http.get(NOTIFICATION_SERVICE.getEmail + '/' + Id)
  }
  
}
